export default __webpack_public_path__ + "static/media/Logo.175cdda3.png";